// hooks
import { useQuery } from 'react-query';
import { getFlexMatchCandidates } from 'RestAPIs/flex-match';

const useGetFlexMatchCandidates = (
  { requestId },
  options: Record<string, any> = {}
) => {
  return useQuery(
    ['flexMatchCandidates', requestId],
    async () => {
      const { data } = await getFlexMatchCandidates({ requestId });
      return data;
    },
    {
      ...options
    }
  );
};

export default useGetFlexMatchCandidates;
